import { render, staticRenderFns } from "./borrow.vue?vue&type=template&id=60cded11&scoped=true"
import script from "./borrow.vue?vue&type=script&lang=js"
export * from "./borrow.vue?vue&type=script&lang=js"
import style0 from "./borrow.vue?vue&type=style&index=0&id=60cded11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cded11",
  null
  
)

export default component.exports